/** DOM ID for the Grid header (columns) */
export const GRID_DOM_HEADER = 'grid-header' as const

/** DOM ID for the Grid body (cue rows) */
export const GRID_DOM_BODY = 'grid-body' as const

/**
 * Space-separated list of IDs to use in `aria-owns=""` property.
 * It is ordered to that the header appear before body for accesibility.
 *
 * @note TODO: This is temp. measure to avoid refactoring the rundown body
 * so that column headers live inside the `role="grid"`.
 */
export const GRID_DOM_OWNERSHIP = `${GRID_DOM_HEADER} ${GRID_DOM_BODY}` as const
